import SubscriptionList from "../components/SubscriptionList";

const ListSubscriptionPage = () => {
  return (
    <SubscriptionList />
  );
};

export default ListSubscriptionPage;
